module.exports = __webpack_public_path__ + "images/emoji/nine.f9e6be02a4415a2c23fc.png";